export default {
  女装: "Kincên jinan",
  男装: "Mêr",
  手机和小工具: "Têlefonên mobîl û amûrên piçûk",
  居家生活: "Jiyana malê",
  电脑及周边设备: "Amûrên komputer û peravê",
  美容及个人护理: "Bedewî û lênêrîna kesane",
  家用电器: "Pêvdank",
  健康与保健: "Lênihêrîna tenduristî û tenduristiyê",
  食品和饮料: "Xwarin û vexwarin",
  玩具_儿童和婴儿: "Pêlîstok, zarok û pitikan",
  童装时尚: "Kincên Kincê Zarokan",
  视频游戏: "Lîstikên vîdyoyê",
  运动与户外: "Xebat û derveyî",
  爱好与书籍: "Hogir û pirtûk",
  相机和无人机: "Kamer û dron",
  宠物食品及用品: "Xwarin û amûrên pet",
  女士包袋: "Bag Bag",
  男士包袋: "Kulika mêran",
  珠宝及配饰: "Zewac û amûrên",
  手表: "seet",
  女鞋: "Kincên jinan",
  男装鞋: "Kincên mêran",
  汽车: "trimbêl",
  我附近的ShopeePay: "My Firotgeha min",
  餐饮_旅行和服务: "Catering, Rêwîtî û Xizmet",
  旅行及行李: "Rêwîtî û bagaj",
  各种各样的: "Newekhev",
  我是来买什么的: "Ez li vir im ku bikirim",
  对不起_找不到_相关的商品:
    "Bibore, hûn nekarin hilberên têkildar [{0}] bibînin",
  类别: "liq",
  产品: "mal",
  店铺: "Dikan",
  首页: "Rûpela pêşîn",
  限时秒杀: "Spike Demek Limited",
  博客: "blog",
  所有品牌: "Hemî markayên",
  所有类别: "Hemî kategorî",
  我的购物车: "Kirîna kirîna min",
  发货信息: "Agahdariya Delivery",
  交货信息: "Agahdariya Delivery",
  付款: "Diravdanî",
  确认: "tesdîqkirin",
  您的购物车是空的: "Kirîna kirîna we vala ye",
  价格: "biha",
  税: "Bac",
  数量: "jimarî",
  总计: "hemî",
  移除: "Dûrxistin",
  返回商店: "Vegere firotgehê",
  继续发货: "Delivery bidomînin",
  筛选: "parzûn",
  价格范围: "Biha",
  排序方式: "Sort by",
  最新: "biroj",
  最旧: "Kevn",
  价格从低到高: "Bihayê ji kêm heya bilind",
  价格从高到低: "Bihayê ji bilind",
  选择交货类型: "Tîpa Delivery hilbijêrin",
  送货上门: "Şandinî",
  继续付款: "Bidomînin",
  任何其他信息: "Agahdariya din",
  或者: "an",
  您的钱包余额: "Balansa wiya wiya",
  余额不足: "Balansek ne bes e",
  支付: "Diravdan",
  我同意: "Ez razî me",
  条款和条件: "Termsert û mercên",
  退货政策: "Polîtîkaya vegera",
  隐私政策: "Taybetî",
  概括: "Kom kirin",
  项目: "rêvename",
  全部的: "Hemî -round",
  小计: "Nexş",
  总运费: "Tevgera tevahî",
  有优惠码吗_在这里输入: "Kodek daxistinê heye? Li vir têkevin",
  申请: "Bikaranîn",
  编辑: "weşandin",
  删除: "lûleêkirin",
  添加新地址: "Navnîşana nû zêde bikin",
  继续交货信息: "Agahdariya Delivery bidomînin",
  选择一个地址: "Navnîşek hilbijêrin",
  购买历史: "Dîrok bikirin",
  下载: "daketin",
  已发送退款请求: "Daxwaza vegerandinê daxwaznameyek vegerandinê dişîne",
  对比: "dijîtî",
  对话: "Diyalog",
  我的钱包: "Dîwar min",
  工单: "Fermana kar",
  管理个人资料: "Agahdariya kesane birêve bibin",
  登出: "Guhê xwe nedene",
  重置对比列表: "Lîsteya berhevdanê vekişînin",
  您的对比列表为空: "Navnîşa berhevoka we vala ye",
  在您的购物车中: "Di kirîna kirîna xwe de",
  在您的愿望清单中: "Di navnîşa xwesteka we de",
  在您的预定列表中: "Di navnîşa we ya plansazkirî de",
  下载您的产品: "Hilbera xwe dakêşin",
  选项: "Dibe",
  什么都没找到: "Min tiştek nedît",
  特色产品: "Hilbera taybetî",
  最畅销: "Best -selling",
  前_名: "Berê {0}",
  查看更多: "Zêdetir bibînin",
  查看所有类别: "Hemî kategoriyan binêrin",
  十大品牌: "Deh markayên top",
  查看所有品牌: "Hemî markayên temaşe bikin",
  登录: "Têkeve",
  手机号码: "jimare telefon",
  密码: "şîfre",
  密码长度为6到16个字符: "Dirêjahiya şîfreyê 6 ji 16 tîpan e",
  验证码: "Koda verastkirinê",
  登录中: "Têkeve",
  游客登录: "Têketina geştyar",
  注册您的商店: "Firoşgeha xwe qeyd bikin",
  现在申请: "Naha bicîh bikin",
  成为商家: "Dibin bazirgan",
  现在注册: "Naha qeyd bikin",
  登录成功: "Têketina serfiraz",
  通知: "agahdan",
  未找到通知: "Nasîn",
  评论: "Agahkişî",
  估计运输时间: "Wexta Veguhestinê ya texmînkirî",
  天: "asûman",
  所售: "Firotin",
  给商家留言: "Peyamek ji bazirganan re bihêle",
  规格: "Kenivîs",
  库存: "ez bêzarim",
  总价: "Buhayê Giştî",
  添加到购物车: "Têxe selikê",
  立即购买: "Naha bikirin",
  缺货: "balkeş nîne",
  添加到愿望清单: "Li lîsteya xwestekên xwe zêde bike",
  加入对比列表: "Lîsteya berhevdanê zêde bikin",
  退款: "Şûndadan",
  查看条款: "Clause bibînin",
  分享: "par",
  描述: "terîfkirin",
  相关产品: "Berhemên têkildar",
  没有人问过商家: "Kes ji bazirganan pirs nekiriye",
  该产品暂无评论: "Li ser vê hilberê şîroveyek tune",
  客户评论: "Commentîroveya Mişterî",
  访问商店: "Serdana Store",
  畅销产品: "Berhemên çêtirîn-bijare",
  日期: "rojek",
  订单编号: "Hejmara fermanê",
  总额: "başim sipas",
  状态: "rewş",
  愿望清单: "Lîsteya Wish",
  还没有添加任何东西: "Heya niha tiştek nehatiye zêdekirin",
  注册: "fêhrist",
  邀请码: "Koda vexwendinê",
  请输入邀请码: "Ji kerema xwe kodê vexwendinê binivîse",
  用户名: "Navê bikarhêner",
  请输入用户名: "Ji kerema xwe navê bikarhêner binivîse",
  用户名长度为6_14个字符: "Dirêjahiya navê bikarhêner 6-14 tîp e",
  昵称: "Navê Nick",
  请输入手机号码: "Ji kerema xwe hejmara telefona desta binivîse",
  手机号码格式错误: "Errorewtiya Formateya Hejmara Telefonê Mobile",
  密码长度为6_16个字符: "Dirêjahiya şîfreyê 6-16 tîpan e",
  确认密码: "di pêşîyê da em sipas dikin",
  请输入确认密码: "Ji kerema xwe şîfreya pejirandinê binivîse",
  提款密码: "Passwordîfreya vekişînê",
  请输入提款密码: "Ji kerema xwe şîfreya vekişînê binivîse",
  提款密码长度为4_16个字符: "Dirêjahiya şîfreya vekişînê 4-16 tîpan e",
  请输入验证码: "Ji kerema xwe kodê verastkirinê binivîse",
  在_s后发送: "Piştî {0-ê bişînin",
  发送验证码: "Koda verastkirinê bişînin",
  注册即表示您同意我们的条款和条件:
    "Tomarbûn tê vê wateyê ku hûn bi şert û mercên me razî ne.",
  创建账号: "Hesabek çêbikin",
  验证码发送成功: "Koda verastkirinê bi serfirazî dişîne",
  确认密码不一致: "Bawer bikin ku şîfreya nerazî ye",
  提款密码必须为数字: "Pêdivî ye ku şîfreya vekişînê were hejmartin",
  注册成功: "Bi serfirazî tomar bikin",
  购物车: "Kirîna kirîn",
  账户: "Konto",
  我的账户: "Hesabê min",
  已经有一个账户: "Jixwe hesabek heye",
  新地址: "Navnîşana Nû",
  编辑地址: "Navnîşa Edîtorê",
  保存: "rizgarkirin",
  是否默认: "Gelo xwerû",
  具体地址: "Navnîşana taybetî",
  请输入具体地址: "Ji kerema xwe navnîşana taybetî binivîse",
  地区: "dewer",
  请输入地区: "Ji kerema xwe navçeyê binivîse",
  城市: "Bajar",
  请输入城市: "Ji kerema xwe bajêr binivîse",
  省份: "herêm",
  请输入省份: "Ji kerema xwe li parêzgehê binivîse",
  邮政编码: "koda postê",
  请输入邮政编码: "Ji kerema xwe kodê posteyê binivîse",
  电话号码: "Hejmara têlefonê",
  请输入电话号码: "Ji kerema xwe hejmara têlefonê binivîse",
  收货人: "Consignee",
  请输入收货人: "Ji kerema xwe Consignee binivîse",
  保存成功: "Serfiraz be",
  最畅销的商家: "Bazirganê herî baş-bijare",
  查看所有的商家: "Hemî bazirganan kontrol bikin",
  支持政策: "Polîtîkaya Piştgiriyê",
  您的电子邮件地址: "Navnîşana e-nameya we",
  订阅: "abonetî",
  联系方式: "Agahdariya têkiliyê",
  地址: "navnîşan",
  美国伊利诺伊州霍夫曼庄园: "Holfman Manor, Illinois, USA",
  快速链接: "Girêdana zû",
  商家政策: "Siyaseta Merchant",
  submit: "nermijîn",
  提款银行卡: "ADBB CARD",
  我的面板: "Panelê min",
  提示: "geşî",
  确定登出吗: "Ma hûn guman dikin ku hûn têkevinê?",
  确定: "Emîn",
  取消: "Bişûndekirin",
  项目添加到您的购物车: "Projeya li kirîna kirîna we tê zêdekirin",
  经常一起购买: "Bi gelemperî bikirin",
  返回购物: "Firotina vegera",
  进行结算: "berbi kontrolê ve biçin",
  帮助热线: "HOTLINE HOTLINE",
  查看所有通知: "Hemî agahdariyan kontrol bikin",
  请输入密码: "Ji kerema xwe şîfreya binivîse",
  前往充值: "Herin Recharge",
  购物车物品: "Kirîna kirîn",
  查看购物车: "Firotgeha kirînê kontrol bikin",
  钱包余额: "Balansa Wallet",
  充值钱包: "Bagaja nûvekirinê",
  钱包充值_线下_: "Wallet Recharge (Offline)",
  申请提款: "Serlêdana vekişandinê bikin",
  钱包收支明细: "Daxuyaniyên Dahata Wallet û Daxuyaniyên Lêçûnê",
  批准: "destûrdan",
  提现历史记录: "Danasîna dîrokî",
  类型: "awa",
  信息: "agahî",
  付款方式: "Rêbaza Payment",
  请选择付款方式: "Ji kerema xwe rêbaziya dayînê hilbijêrin",
  Bill_Type_RECHARGE_BACK: "Recharge paşnavê",
  Bill_Type_RECHARGE_ONLINE: "Recharge serhêl",
  Bill_Type_RECHARGE_REGISTER: "Fêhrist",
  Bill_Type_RECHARGE_JACKPOT: "Recharkirin",
  Bill_Type_RECHARGE_PRESENT: "Xelata nûvekirinê",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Veguhestina Komîsyonê",
  Bill_Type_RECHARGE_TG_COMMISSION: "Komîsyona Pêşkeftinê Recharge",
  Bill_Type_REGISTER_TG_COMMISSION: "Komîsyona Register û Pêşkeftinê",
  Bill_Type_WITHDRAW: "Vekişandin",
  Bill_Type_WITHDRAW_REJECT: "Vekişandin",
  Bill_Type_DEDUCT_HANDLE: "Daketin dakêşin",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Recharkirin",
  Bill_Type_MINING_PROFIT: "Dahata Mining",
  Bill_Type_MINING_PROFIT_COMMISSION: "Komîsyona Pêşkeftina Dahata Mining",
  Bill_Type_VIP_UPGRADE: "Upgrade VIP",
  Bill_Type_FINANCE_BUY: "Kirîna hilberîna rêveberiya dewlemendiyê",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Vegera balansa darayî",
  Bill_Type_FINANCE_FEE: "Hezkirina darayî",
  Bill_Type_FINANCE_PROFIT: "Dahata darayî",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Komîsyonên Kirînê ji bo hilberên rêveberiya dewlemendiyê",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Komîsyona Karisî ya Hilberîna Rêvebiriya Dewlemendiyê",
  Bill_Type_WHEEL_DRAW: "Rêzikên Turntable Big",
  Bill_Type_BUY: "Tiştên bikirin",
  Bill_Type_PAY_SHOP: "Xerca radestkirinê bidin",
  Bill_Type_BUY_COMMISSION: "Komîsyona Berheman Bikirin",
  Bill_Type_DEPOSIT: "Depo deynek bidin",
  Bill_Type_STORE_BUY: "Tiştên bikirin",
  Bill_Type_STORE_BUY_REFUND: "Tezmînatê bikirin",
  Bill_Type: "Cureya Guhertina Deyn",
  Before_Money: "Mîqdara berê",
  Deal_Money: "Mîqdara Guhertina Hesabê",
  After_Money: "Hêjeya paşê",
  Bill_Time: "Demjimêrê Guhertina Hesabê",
  No_More_Data: "No daneyên din",
  Apply_Money: "Mîqdara serîlêdanê",
  Apply_Time: "Dema serîlêdanê",
  Withdraw_Info: "Hezkirina heqê: {heqê}, ji hesabê: {pere",
  提款订单状态_CHECKING: "Bêne lêkolîn kirin",
  提款订单状态_TRANSFERRING: "Derbaskirin",
  提款订单状态_PASS: "Tesdîqkirin",
  提款订单状态_REJECT: "Reparted",
  暂无可用充值方式: "Meto rêbazek ji nû ve tune",
  钱包收款码: "Koda berhevkirina Wallet",
  钱包地址: "Navnîşana Wallet",
  金额限制: "Sînorê mîqdara",
  复制: "kopî",
  付款凭证: "Voucher Payment",
  收款银行: "Banka wergirtinê",
  收款人: "Diravgir",
  收款账号: "Hesabê wergirtinê",
  付款银行: "Bankeyê bidin",
  付款人: "Dirav",
  付款账号: "Hesabê dayînê",
  请输入付款银行: "Ji kerema xwe banka dravdanê binivîse",
  请输入付款人: "Ji kerema xwe payer binivîse",
  请输入付款账号: "Ji kerema xwe hesabê dravdanê binivîse",
  请上传付款凭证: "Ji kerema xwe vokalên drav bidin",
  充值金额: "Mîqdara Ragihandinê",
  请输入充值金额: "Ji kerema xwe mîqdara dravdanê binivîse",
  submitting: "Radest kirin ...",
  Confirm: "nermijîn",
  Commit_Success: "Radestkirina serfiraz",
  balanceType_BALANCE: "Bîlanço",
  balanceType_COMMISSION: "simsarî",
  Balance: "Balansa hesabê",
  Wash_Money: "Kodakirin",
  请选择银行账户: "Ji kerema xwe hesabê bankê hilbijêrin",
  卡号类型: "Hejmara karta",
  提现金额: "Dravê vekişînê",
  提款金额: "Dravê vekişînê",
  不能为空: "Nikare vala be",
  金额不正确: "Mîqdara çewt",
  please_input_withdraw_password: "Ji kerema xwe şîfreya vekişînê binivîse",
  withdraw_password_format_error:
    "Pêdivî ye ku şîfreya vekişînê ji 4-16-bit tîpan be",
  Fee: "Heqê meşandinê",
  实际到账: "Birastî",
  交易币种: "Dravê bazirganiyê",
  原始密码: "Passwordîfreya Primitive",
  confirm_password_error: "Passwordîfreya du inputan şaş e",
  save_success: "Serfiraz be",
  please_input: "Ji kerema xwe binivîse",
  old_password: "Passwordîfreya kevin",
  new_password: "Passwordîfreya nû",
  please_input_confirm_password: "Ji kerema xwe şîfreya dîsa piştrast bikin",
  没有找到符合条件的商品: "Nikare hilberên jêhatî bibîne",
  Search: "gerr",
  全部: "gişt",
  EnumGoodsOrderState_USER_PAY: "Da ku were belav kirin",
  EnumGoodsOrderState_SHOP_PAY: "Belavkirinî",
  EnumGoodsOrderState_SUCCESS: "Qedandin",
  EnumGoodsOrderState_CANCEL: "Bişûndekirin",
  EnumGoodsOrderState_REFUND_SUCCESS: "Şûndadan",
  订单号: "Hejmara fermanê",
  用户名称: "Navê bikarhêner",
  收益: "hatin",
  支付时间: "Dema drav",
  配送时间: "Dema radestkirinê",
  完成时间: "Wextê temam",
  发货: "Gemî",
  全选: "Hilbijartina tevahî",
  物品已添加到愿望清单: "Tiştên li navnîşa xwestî hatine zêdekirin",
  物品已添加到比较列表: "Tiştên li navnîşa berhevdanê hatine zêdekirin",
  购买成功提示: "Xwezî, bi serfirazî bikirin",
  订单列表: "Navnîşa Order",
  商品名: "Navê Hilbera",
  图片: "sûret",
  没有品牌: "Bê marqeyek",
  基本信息: "Agahdariya bingehîn",
  Account_Name: "Nav",
  Bank_Account: "Hesabê bankê",
  Bank_Phone: "Hejmara têlefona desta ya tomar bikin",
  IFSC: "Hesabê IFSC",
  UPI: "Hesabê UPI",
  PIX: "Hejmara Hesabê Pix",
  CPF: "Hesabê CPF",
  GCASH: "Hesabê Gcash",
  POWWI: "Hesabê Powwi",
  身份证号: "Jimara nasnameyê",
  Edit: "Şûndeavêtin",
  Delete: "lûleêkirin",
  Add: "Zêdekirin",
  Forget_Withdraw_Password: "Bi şîfreya vekişînê ji bîr bikin",
  Bank_Card_Info: "Agahdariya Karta Bankê",
  收款人地址: "Navnîşa Cashier",
  SWIFT: "Bilêvkirin",
  Bank_Branch: "Navê sub -branch",
  分行代码: "Koda Branaxê",
  银行地址: "Navnîşa Bankê",
  Email: "Email",
  银行卡长度必须超过:
    "Dirêjahiya karta bankê pêdivî ye ku ji {dirêj ve derbas bibe",
  银行卡格式不正确: "Forma karta bankê şaş e",
  Do_you_confirm_delete: "Ma hûn piştrast dikin?",
  Please_Login_First: "Ji kerema xwe yekem têkevin",
  Bank_Name: "Navê bankê",
  Please_add_bank_first:
    "We karta bankê negirtiye, ji kerema xwe pêşî lê zêde bike",
  withdrawType: "Vekişandin",
  withdraw_money_limit:
    "Mîqdara vekişînê divê ji 0 û kêmtir an wekhev ji {balansê re be",
  withdraw_times_limit:
    "Todayro we îro todaywithdrawnum kir. Piştî {LimittIMes} car caran, hûn ê ji %% ji heqê desta berdanê bidin. Ma ew biryar e ku meriv drav vekişîne?",
  Copy_Success: "Replînasyon",
  商店首页: "Malpera hilanînê",
  所有产品: "Hemî hilber",
  新到货产品: "Hilbera -arval nû",
  所有商家: "Hemî bazirganan",
  请上传: "Ji kerema xwe barkirin",
  请输入: "Ji kerema xwe binivîse",
  忘记密码: "Passwordîfreya ji bîr bikin",
  记得我: "Min bîne bîra xwe",
  共_件: "Total {0} Piçek",
  取消订单: "Fermanê betal bikin",
  申请退款: "Ji bo vegera serlêdanê bikin",
  未知商家: "Bazirganê nenas",
  到账: "Konto",
  提款订单状态: "Rewşek fermana vekişînê",
  前_名类别: "Kategoriya yekem {0}",
  取消订单原因_不想要了: "Êdî naxwazin",
  取消订单原因_商品错选_多选: "Xeletiyên Hilbera / Hilbijarka Pirjimar",
  取消订单原因_商品无货: "Out -of -Goods",
  取消订单原因_地址信息填写错误: "Errorewtiya agahdariya navnîşanê dagirin",
  取消订单原因_商品降价: "Kêmkirina bihayê bihayê",
  取消订单原因_价格高于其他平台: "Buhayê ji platformên din bilindtir e",
  取消订单原因_没用_少用_错用优惠:
    "Tiştek / kêmkirina kêm / xeletiyê bikar neynin",
  退款原因_拍错_多拍_不喜欢: "Zêdetir / wê bikişînin / hez nekin",
  退款原因_商品成分描述不符: "Danûstendina Hilbera Hilbera Product Match",
  退款原因_与商家协商一致退款: "Consultêwirmendî bi vegera bazirganan",
  退款原因_生产日期_保质期与商品描述不符:
    "Dîroka hilberînê / Sefferê bi danasîna hilberê re têkildar nabe",
  退款原因_图片_产地_批号_规格等描述不符:
    "Wêne / Cihê Origin / Hejmara Batch / Taybetmendî, hwd.",
  退款原因_质量问题: "Mijara Quality",
  退款原因_商品变质_发霉_有异物: "Hilberîna hilberê / laşê xerîb / biyanî",
  退款原因_少件_含缺少配件_: "Tiştên piçûk (tevî kêmbûna amûrên)",
  退款原因_收到商品时有破损_污渍_变形:
    "Dema ku hilberê wergirtin, zirarek / stûn / deformasyon heye",
  退款原因_假冒品牌: "Qelp",
  退款原因_发票问题: "Pirsgirêka fatûreyê",
  退款原因_商家发错货: "Bazirgan tiştên çewt dişînin",
  退款原因_预约不到_商家不给退换: "Nikare serlêdan / bazirgan neyê vegerandin",
  退款失败: "Revçûna Revinê",
  退款处理中: "Pêvajoya vegerandinê",
  默认: "destçûnî",
  产品查询: "Pirsa hilberê",
  商店LOGO: "Logo bikirin",
  推广码: "Koda Pêşkeftinê",
  查看所有: "Hemî kontrol bikin",
  确认收货成功: "Bawer bikin ku wergirtin serkeftî ye",
  物流公司: "Pargîdaniya lojîstîkî",
  物流单号: "Hejmara fermana lojîstîkî",
  发货时间: "Dema radestkirinê",
  请先选择商品规格: "Ji kerema xwe yekem specification hilberê hilbijêrin",
  个人信息: "Agahdariya kesane",
  您的用户名: "Navê te",
  你的名字: "Navê te",
  登录名: "Navê bikarhêner",
  你的邮件: "Nameya we",
  你的密码: "Şîfreya we",
  重复输入密码: "Passwordîfreya dubare bikin",
  店铺名称: "Navê Firotanê",
  证书类型: "Awa",
  身份证: "Karta ID",
  护照: "pesport",
  驾驶执照: "Lîsansa Driver",
  社会保障卡: "Karta Ewlehiya Civakî",
  证书正面: "Belgeya erênî",
  证书反面: "Delîl",
  确认收货: "Pêşwaziya tiştên piştrast bikin",
  请选择取消订单的原因必选:
    "Ji kerema xwe sedem ji bo betalkirina fermanê (pêwîst) hilbijêrin:",
  请选择申请退款的原因必选:
    "Ji kerema xwe sedemên serlêdana ji bo vegera (pêwîst) hilbijêrin:",
  留言: "agah",
  请输入留言: "Ji kerema xwe peyamek binivîse",
  没有帐户: "No Hesab",
  钱包充值: "Wallet Recharge",
  输入您的文字: "Nivîsa xwe binivîse",
  商家登录: "Login Merchant",
  有关此产品的任何查询: "Her pirsek li ser vê hilberê",
  产品名称: "Navê Hilbera",
  你的问题: "Pirsgirêka we",
  白银店铺: "Firoşgeha Zîv",
  铂金店铺: "Firoşgeha Platinum",
  钻石店铺: "Diamond Shop",
  照片: "wêne",
  已退货: "Vegeriyan",
  邮寄状态: "Rewşa nameyê",
  订单摘要: "Abstrakt",
  收件地址: "Navnîşa hatinê",
  订购日期: "Dîroka Order",
  订单状态: "Rewşa Order",
  总订单金额: "Mîqdara tevahî ya fermanê",
  邮寄方式: "Rêbaza nameşandinê",
  附加信息: "Agahiyên Zêdeyî",
  订单详细信息: "Agahdariya berfireh",
  交货类型: "Cureya radestkirinê",
  进行评论: "Agahkişî",
  已评论: "Şîrove kirin",
  订单金额: "Mîqdara fermanê",
  优惠券: "Kupon",
  统一运费: "Firotina yekgirtî",
  送货地址: "Navnîşa Shippingandina",
  评分: "rewşa nixtan",
  你的意见: "Ramana we",
  匿名: "bênav",
  现金: "perê pêşîn",
  详情: "Hûrî",
  收货地址: "Navnîşana wergirtinê",
  暂时没有对话: "Ji bo dema hebûnê diyalog tune",
  你: "hûn",
  输入您的回复: "Bersiva xwe binivîse",
  删除成功: "Lûleêkirin",
  品牌: "nîşan",
  已缴纳的保证金: "Marjînal daye",
  黄金店铺: "Firoşgeha Zêrîn",
  没有更多数据: "No daneyên din",
  站内信: "Letter-nameyê",
  系统通知: "Nîşana pergalê",
  邮箱: "Poste",
  手机号: "Jimare telefon",
  你的手机号: "Hejmara têlefona weya desta",
  营业执照: "Lîsansa Karsaziyê",
  你的邮箱: "Qutiya nameya we",
  搜索结果: "Encamên lêgerînê",
  系统公告: "Daxuyaniya pergalê",
  客服: "balkeş bûn",
  消息已撤回: "Nûçe hate vekişandin",
  物流详情: "Hûrguliyên lojîstîkî",
  充值: "Top Up",
  提现: "Vekişandin",
  信用分: "Krêdî",
  余额: "Bîlanço",
  佣金: "simsarî",
  继续购物: "Kirîna xwe bidomînin",
  订单结算: "Order bicîh bikin",
  加入对比: "Berhevokê zêde bikin",
  佣金余额: "Balansa Komîsyonê",
  刷新: "hênikkirin",
  刷新成功: "Hênikkirin",
  官网: "Malpera Fermî",
  税号: "Hejmara bacê",
  订单: "Emir",
  合计: "hemî",
  系统安全: "Ewlekariya Pergalê",
  Recharge_Money_Limit: "Mîqdara Ragihandinê di navbera MIN} û {MAX-ê de be",
  限时优惠: "Demek sînorkirî",
  高价回收: "Rizgarkirina bilind-hişk",
  姓名: "Nav",
  商品订单号: "Hejmara Fermana Odeya",
  商品在线回收: "Veguhastina serhêl a komariyê",
  提交: "nermijîn",
  回收记录: "Record Record",
  回收状态: "Rewşa Ragihandinê",
  回收价格: "Bihayê nûvekirinê",
  纳税码: "Koda bacê",
  买家登录: "Têkeve",
  买家注册: "fêhrist",
  language: "Çînî",
  助力提示:
    "Alîkariya bazirganan dikare berfirehbûna platformê li firotgehên wan zêde bike, û hejmara duduyan ya herî zêde ya rojhilatê, mezinahiya bilindtir.",
  已累计助力: "Cumulatively arîkar kirin",
  今日已助力: "Îro alîkarî kiriye",
  立即助力: "Di cih de bibin alîkar",
  商家助力: "Arîkariya bazirganan",
  证件号码: "Jimara nasnameyê",
  证书号码: "Hejmara Sertîfîkayê"
};
